import React from 'react'
import { styled } from '@mui/material/styles'
import Box from '@mui/material/Box'
import CircularProgress from '@mui/material/CircularProgress'

export interface LoadingProps {
  className?: string
  isLoading?: boolean
  size?: number
  color?: string
}

const Container = styled(Box)({
  width: '100%',
  height: '100%',
  position: 'absolute',
  top: 0,
  right: 0,
  bottom: 0,
  left: 0,
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  zIndex: 9999,
  background: 'rgba(0, 0, 0, 0.22)',
})

const Loading: React.FC<LoadingProps> = ({ children, isLoading }) =>
  typeof isLoading === 'undefined' || !!isLoading ? (
    <Container>
      <Box style={{ position: 'relative', top: '-8%' }}>
        <CircularProgress
          aria-describedby="Loading..."
          aria-busy={!!isLoading}
          size={35}
          thickness={3}
        />
        <span style={{ color: '#333', margin: '6px auto' }}>{children}</span>
      </Box>
    </Container>
  ) : null

export default Loading
